export default __webpack_public_path__ + "static/hikyccase2-c5bcb2dc7003504e5da2929c15e8033b.png";